import React from 'react'

const NoDataImage = ({ imageURL, height, width }) => {
  const style = {}
  if (height) style.height = height
  if (width) style.width = width

  return (
    <div
      className="no-data-msg"
      style={Object.keys(style).length > 0 ? style : null}
    >
      <img
        src={imageURL}
        alt="Data is not available"
        style={Object.keys(style).length > 0 ? style : null}
      />
    </div>
  )
}

export default NoDataImage
